const React = require('react');

const SectionHeader = ({ title, messages = [] }) => (
  <>
    <h1 className="reference-home-title">{title}</h1>
    {messages && messages.length > 0
        && messages.map((message) => (<p className="reference-home-message">{message}</p>))}
  </>
);

module.exports = SectionHeader;
